import UAParser from "ua-parser-js"

export const SCREEN_SIZES = {
  MOBILE: 999,
  DESKTOP_MIN: 1000,
  DESKTOP_MIDDLE: 1400,
}

const size = {
  mobile: `(max-width: ${SCREEN_SIZES.MOBILE}px)`,
  desktop: `(min-width: ${SCREEN_SIZES.DESKTOP_MIN}px)`,
  middleDesktop: `(max-width: ${SCREEN_SIZES.DESKTOP_MIDDLE}px) and (min-width: ${SCREEN_SIZES.DESKTOP_MIN}px)`,
  middleDesktopOrLess: `(max-width: ${SCREEN_SIZES.DESKTOP_MIDDLE}px)`,
}

export const mediaQuerySize = size

const mediaQueryFor = {
  mobile: `@media ${size.mobile}`,
  desktop: `@media ${size.desktop}`,
  middleDesktop: `@media ${size.middleDesktop}`,
  middleDesktopOrLess: `@media ${size.middleDesktopOrLess}`,
}

export type MediaT = "mobile" | "desktop"

export function queryMedia(): MediaT {
  if (typeof window === "undefined") return "desktop"

  const requests = {
    mobile: window.matchMedia(size.mobile).matches,
    desktop: window.matchMedia(size.desktop).matches,
  }

  const fallback = ["desktop", true]
  const [media] = Object.entries(requests).find(([_, v]) => v) ?? fallback

  return media as MediaT
}

export function extractMediaFromUserAgent(ua: string): MediaT {
  const uaParser = new UAParser(ua)

  const isMobile =
    uaParser.getDevice().type === "mobile" ||
    [
      "iOS",
      "Android",
      "Android-x86",
      "Windows Phone",
      "Windows Mobile",
    ].includes(uaParser.getOS().name ?? "")

  return isMobile ? "mobile" : "desktop"
}

export function subscribeMedia(fn: (media: MediaT) => void): void {
  const medias: MediaT[] = ["desktop", "mobile"]

  const sub = (key: MediaT) => (ev: MediaQueryListEvent) => {
    if (ev.matches) fn(key)
  }

  medias.forEach(media => {
    window.matchMedia(size[media]).addEventListener("change", sub(media))
  })
}

export default mediaQueryFor
